<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="modalData.title"
        :show-close="false"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <div class="clearfix">
            <div v-if="modalData.name=='yy_type'">
                <el-form ref="form" label-width="80px" label-position="left" class="pr40">
                    <el-form-item label="Dimension:" class="label-required">
                        <el-select v-model="formItem.select" @change="changeSelect" :disabled="isView" placeholder="Please select">
                            <el-option
                                v-for="item in optionList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="search-wrap fl">
                <div>
                    <div class="relative" :class="[isAutoLoad?'ml60':'ml30']">
                        <el-dropdown @command="changeIsExclude" :disabled="isView" class="exclude-drop" :class="isAutoLoad?'':'left30'" trigger="click" placement="bottom-start">
                            <span class="el-dropdown-link">
                                <span v-if="formItem.isExclude && modalData.name != 'time_zone' " class="icon iconfont icon-jt-paichu text-color-error" title="exclude"></span>
                                <span v-else class="icon iconfont icon-jt-invert-full active-icon" title="include"></span>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command=""><span :class="formItem.isExclude?'':'active-icon'" class="icon iconfont icon-jt-invert-full ver-middle"></span>Include</el-dropdown-item>
                                <el-dropdown-item  v-if="modalData.name != 'time_zone'" command="exclude" class="text-color-error"><span class="icon iconfont icon-jt-paichu ver-middle"></span> Exclude</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span class="copy-btn-icon el-icon-document-copy" @click="showBatchModal" title="Batch Select" v-if="isAutoLoad"></span>
                        <el-input v-model="formItem.search" ref="searchInput" @input="changeSearchText" :autofocus="true" clearable placeholder="Enter Keyword to Search"></el-input>
                    </div>
                    <div class="search-list"  @scroll="scrollList">
                        <ul v-loading="dataList.length<=0&&searchLoading">
                            <li class="mt4 mb4" v-if="dataList.length>0&&formItem.search.length>0">
                                <el-checkbox v-model="isSelectAll" :disabled="isView" @change="selectAll">Select All</el-checkbox>
                            </li>
                            <li class="mt4 mb4" v-for="(item,index) in dataList" :key="item.id+''+index" :class="item.isHide?'hide-item':''">
                                <el-checkbox v-model="item.checked" :disabled="isView" @change="itemCheckChange(item,$event)">
                                    {{item.name}}
                                </el-checkbox>
                            </li>
                            <li class="mt4 mb4" v-if="!searchLoading&&dataList.length<=0">
                                <p class="tac">No data available</p>
                            </li>
                            <li class="mt4 mb4" v-if="searchLoading">
                                <p class="tac text-color-gray">loading...</p>
                            </li>
                            <li class="mt4 mb4" v-if="isEnd">
                                <p class="tac text-color-gray">There's nothing more</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="result-wrap fl">
                <h3 class="font12px relative">（{{resultList.length}}） Selected<span
                    class="text-color-error pointer absolute " v-show="!isView" style="right:10px;" @click="clearResultList">Clear</span>
                </h3>
                <div class="result-list">
                    <ul>
                        <li v-for="(item,index) in resultList" :key="item.id+''+index" class="relative mt4 mb4 font12px">{{item.name}}
                            <span class="clear-btn pointer text-color-error p4 absolute" @click="clearResultItem(item)"
                                  title="Delete" v-show="!isView">x</span>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
        <div slot="footer" class="dialog-footer tac">
            <template v-if="isView">
                <el-button type="primary" @click="hideModal" class="action-btn ml20">Close</el-button>
            </template>
            <template v-else>
                <el-button type="default" @click="hideModal" class="action-btn mr20">Cancel</el-button>
                <el-button type="primary" @click="handleSubmit" :disabled="searchLoading" :loading="submitLoading" class="action-btn ml20">Submit</el-button>
            </template>
        </div>

        <el-dialog
            width="520px"
            :title="'Batch select '+modalData.title"
            :visible.sync="batchVisible"
            :show-close="false"
            class="batch-modal"
            append-to-body>
            <div>
                <p class="text-color-gray mb10">Enter or Paste {{modalData.title}}， One Per Line</p>
                <div class="batch-content">
                    <el-input
                        type="textarea"
                        placeholder="Please Enter Content"
                        v-model="batchCon"
                        :rows="10"
                        resize="none"
                        style="min-height: 200px;"
                        :autofocus="true"
                    >
                    </el-input>
                </div>
                <p class="tac mt20">
                    <el-button type="default" @click="hideBatchModal" class="action-btn mr20">Cancel</el-button>
                    <el-button type="primary" @click="submitBatchModal" :loading="batchLoading" class="action-btn ml20">Submit
                    </el-button>
                </p>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import API from '@/api/efficiencyToolEn/template_new.js';

    export default {
        name: "ContentModal",
        components: {},
        props: {
            modalData: {
                type: Object,
                required: true,
            },
            condition:{
                type: Array,
                required: true,
            },
            platId:{
                type: [String,Number],
                required: true,
            },
            autoLoadFields:{
                type: Array,
                required: true,
            },
            isTimeFilter:{
                required: false,
                type:Boolean,
                default:false,
            },
        },
        data() {
            return {
                dialogVisible: false,
                autoLoading:false,
                submitLoading: false,
                searchLoading: false,
                formItem: {
                    search: '',
                    isExclude:false,
                    select:'',
                },
                dataList: [],
                resultList: [],
                isSelectAll: false,
                searchTimer:null,
                isEnd:false,
                isAutoLoad:false,
                batchVisible:false,
                batchCon:'',
                batchLoading:false,
                optionList:[],
                ajaxController:null,
                lastSelectVal:'',
            }
        },
        computed: {
            platTimeInterval(){
                if(!this.isTimeFilter) return '';
                return 'hour';
            },
            excludeConditionFields(){
                let conConditions = this.condition.filter(item=>{
                    let fieldConfig = item.config||{};
                    return fieldConfig.type==='content';
                });
                return conConditions.filter(item=>item.isExclude).map(item=>item.name);
            },
            isView(){
                return this.modalData.type == 'info';
            },
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
                clearTimeout(this.searchTimer);
                this.$emit('close',this.modalData);
            },
            resetForm() {
                this.formItem.search = '';
                this.formItem.isExclude = false;
                this.searchLoading = false;
                this.autoLoading = false;
                this.searchTimer = null;
                this.dataList = [];
                this.resultList = [];
            },
            hideModal(){
                this.handleClose();
                // this.$emit('close',this.modalData);
            },
            showModal() {
                this.dialogVisible = true;
                /* 设置自代运营 */
                if(this.modalData.name=='yy_type'){
                    this.optionList = [
                        {
                            value:'bloc_yy_type',
                            label:'By Group',
                        },
                        {
                            value:'company_yy_type',
                            label:'By Client',
                        },
                        {
                            value:'account_yy_type',
                            label:'By Campaign Group',
                        },
                        {
                            label:'按项目',
                            value:'By Project',
                        },
                        {
                            label:'按推广',
                            value:'By Sub Project',
                        },
                        {
                            value:'app_yy_type',
                            label:'By Product',
                        },
                        {
                            value:'plan_yy_type',
                            label:'By Campaign',
                        },
                        {
                            value:'adgroup_yy_type',
                            label:'By Ad Group',
                        },
                        {
                            label:'按关键词',
                            value:'By Keyword',
                        },
                    ];
                }
                this.formItem.select = this.modalData.selectValue||'account_yy_type';
                this.lastSelectVal = this.formItem.select;


                this.resultList = (this.modalData.contentValue||[]).map(item=>{
                    item.checked = true;
                    return item;
                });
                this.getConditions('','');
                this.resetAllState();
                this.isAutoLoad =  this.autoLoadFields.includes(this.modalData.name);
                this.formItem.isExclude = !!this.modalData.isExclude;

            },
            changeSelect(val){
                console.log('changeSelect',val);
                this.resetForm();
                this.getConditions('','');
            },
            handleSubmit() {
                if(!this.isView){
                    let selectItem = this.optionList.find(item=>item.value==this.formItem.select)||{};
                    this.$emit('save-value',Object.assign({},this.modalData,{
                        isExclude:this.formItem.isExclude,
                        select:this.formItem.select,
                        selectLabel:selectItem.label,
                    }),this.resultList,'content');
                }
                this.handleClose();
            },
            getConditions(type,searchText) {
                if (this.ajaxController) this.ajaxController.abort();
                this.ajaxController = new AbortController();
                let conditionData = {};
                this.condition.forEach(item=>{
                    let config = item.config||{};
                    if(config.type=='date_select'){
                        conditionData[item.name] = item.dateValue.join('/');
                        if(item.name=='start_date'){
                            conditionData.start_date_dimension = item.selectValue;
                        }else if(item.name=='create_date'){
                            conditionData.create_date_dimension = item.selectValue;
                        }
                    }else if(config.type=='date'){
                        conditionData[item.name] = item.dateValue.join('/');
                    }else if(config.type=='time'){
                        conditionData[item.name] = item.timeValue.join('/');
                    }else if(config.type=='select'){
                        conditionData[item.name] = item.selectValue;
                    }else{
                        if(item.name=='yy_type'){
                            conditionData.yy_type_dimension = item.selectValue;
                        }
                        conditionData[item.name] = (item.contentValue||[]).map(item=>item.id);
                    }
                });

                if(!(type&&type==='append')){
                    this.dataList = [];
                }
                this.isEnd = false;


                // let searchText = this.formItem.search;

                let returnName = this.modalData.name=='yy_type'?this.modalData.name+'|'+this.formItem.select:this.modalData.name;

                let reqData = {
                    plat_id: this.platId,
                    search: searchText,
                    return_condition: returnName,
                    condition:conditionData,
                    exclude_condition_fields:this.excludeConditionFields.join(','),
                    last:this.dataList.length>0&&this.isAutoLoad&&!searchText?this.dataList[this.dataList.length-1].id:'',
                    signal: this.ajaxController.signal
                };
                if(this.isTimeFilter){
                    reqData.time_interval = this.platTimeInterval;
                }
                this.searchLoading = true;
                API.postTemplateCondition(reqData).then(res => {
                    console.log('getContentSearch',this.formItem.search,'、',searchText);

                    this.searchLoading = false;
                    this.autoLoading = false;
                    let resData = (res.data||{}).list||[];

                    this.$refs.searchInput.focus();

                    if(searchText==this.formItem.search){
                        if(type&&type==='append'){
                            /* 当最后一个为空时,可能会触发无限自动加载，因此如果返回列表已经全部在列表中存在时，就认为到底了 */
                            let isAllInList = resData.map(item=>item.id).filter(item=>!!item).every(item=>this.dataList.map(item=>item.id).includes(item));
                            if(isAllInList||resData.length<=0){
                                clearTimeout(this.searchTimer);
                                this.searchTimer = null;
                                this.isEnd = true;
                            }
                            resData.forEach(item=>{
                                if(!this.dataList.map(item=>item.id).includes(item.id)){
                                    item.id = item.id===null?'':item.id;
                                    item.checked = !!this.resultList.find(inner => inner.id == item.id);
                                    item.isHide = false;
                                    this.dataList.push(item)
                                }
                            });
                        }else {
                            this.dataList = resData.map(item=>{
                                item.id = item.id===null?'':item.id;
                                item.name = item.name||item.id||'';
                                item.checked = !!this.resultList.find(inner => inner.id == item.id);
                                item.isHide = false;
                                return item;
                            })
                        }
                        this.resetAllState();
                    }else{
                        /*表示searchText跟当前input最新值不一致，说明有新的请求，维持loading状态*/
                        this.searchLoading = true;
                    }
                }, (err) => {
                    console.log('getConditions error', err);
                    this.searchLoading = false;
                    this.autoLoading = false;
                    this.dataList = [];
                    // this.$message.error(err.info||'Request Error');
                    let errCondition = err.data || [];
                    if (errCondition.length > 0) {

                        let errStr = '';
                        errCondition.forEach(item=>{
                            errStr = errStr + `<p class="pb6"><span class="text-bold">${item.err_title}</span>${(item.err_msg||[]).join('，')}</p>`;
                        });
                        let htmlStr = `<div class="tal" style="max-height: 300px;overflow: auto;">${errStr}</div>`;

                        this.$confirm(htmlStr, 'The following content do not have permission', {
                            showCancelButton: false,
                            confirmButtonText: 'Ok',
                            type: 'error',
                            center: true,
                            dangerouslyUseHTMLString: true,
                            showClose: false,
                            distinguishCancelAndClose: true,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                        });
                    }else{
                        this.$message.error(err.info||'Request Error');
                    }
                });
            },
            clearResultList() {
                this.resultList = [];
                this.dataList.forEach(item => {
                    item.checked = false;
                });
                this.isSelectAll = false;
            },
            clearResultItem(item) {
                let searchIndex = this.dataList.findIndex(inner => inner.id == item.id);
                let resultIndex = this.resultList.findIndex(inner => inner.id == item.id);
                if (resultIndex != '-1') {
                    this.resultList.splice(resultIndex, 1);
                }
                if (searchIndex != '-1') {
                    this.dataList.find(inner => inner.id == item.id).checked = false;
                }
                this.resetAllState();
            },
            itemCheckChange(item, val) {
                let resultIndex = this.resultList.findIndex(inner => inner.id == item.id);
                if (val) {
                    if (resultIndex == '-1') {
                        this.resultList.unshift(item);
                    }
                } else {
                    if (resultIndex != '-1') {
                        this.resultList.splice(resultIndex, 1);
                    }
                }
                this.resetAllState();
            },
            selectAll(val) {
                this.dataList.forEach(item => {
                    if(!item.isHide){
                        item.checked = val;
                        this.itemCheckChange(item, val);
                    }
                });
            },
            resetAllState() {
                let selectedList = this.dataList.filter(item=>!item.isHide);
                this.isSelectAll = selectedList.length>0&&selectedList.every(item => item.checked);
            },
            changeSearchText(val){
                if(this.isAutoLoad){
                    if(this.searchTimer){
                        clearTimeout(this.searchTimer);
                        this.searchTimer = null;
                    }
                    this.searchTimer = setTimeout(()=>{
                        this.getConditions('',val);
                    },300)
                }else{
                    this.dataList.forEach(item=>{
                        item.isHide = !(item.name||'').toLowerCase().includes(val.toLowerCase());
                    });
                    this.resetAllState();
                }
            },
            scrollList(e){
                if(this.formItem.search!='') return;
                if(!this.isAutoLoad) return;
                let $searchBox = e.target;
                let $ul = $searchBox.querySelector('ul');
                let $ulHeight = $ul.clientHeight;
                if($searchBox.scrollTop>0){
                    if($ulHeight-$searchBox.clientHeight<$searchBox.scrollTop-15){
                        // console.log('到底了');
                        if(this.autoLoading) return ;
                        if(this.isEnd) return;
                        if(this.searchTimer){
                            clearTimeout(this.searchTimer);
                            this.searchTimer = null;
                        }
                        this.searchTimer = setTimeout(()=>{

                            this.autoLoading = true;
                            this.getConditions('append',this.formItem.search);
                        },300)
                    }

                }

            },
            showBatchModal(){
                console.log('showBatchModal');
                this.batchVisible = true;

            },
            hideBatchModal(){
                this.batchVisible = false;
                this.batchCon = '';
            },
            submitBatchModal(){
                console.log('submitBatchModal',this.batchCon.split(/\n/));
                let batchSearch = this.batchCon.split(/\n/).map(item=>item.trim()).filter(item=>!!item);
                if(batchSearch.length<=0){
                    return this.hideBatchModal();
                }
                this.batchLoading = true;

                let conditionData = {};

                this.condition.forEach(item=>{
                    let config = item.config||{};
                    if(config.type=='date_select'){
                        conditionData[item.name] = item.dateValue.join('/');
                        if(item.name=='start_date'){
                            conditionData.start_date_dimension = item.selectValue;
                        }
                    }else if(config.type=='date'){
                        conditionData[item.name] = item.dateValue.join('/');
                    }else if(config.type=='time'){
                        conditionData[item.name] = item.timeValue.join('/');
                    }else if(config.type=='select'){
                        conditionData[item.name] = item.selectValue;
                    }else{
                        conditionData[item.name] = (item.contentValue||[]).map(item=>item.id);
                    }
                });

                let reqData = {
                    plat_id: this.platId,
                    batch_search:batchSearch,
                    return_condition: this.modalData.name,
                    condition:conditionData,
                    exclude_condition_fields:this.excludeConditionFields.join(','),
                };

                if(this.platId=='9'){
                    reqData.time_zone = this.timeZone;
                }
                if(this.isTimeFilter){
                    reqData.time_interval = this.platTimeInterval;
                }

                API.postTemplateCondition(reqData).then(res => {
                    this.batchLoading = false;
                    let resData = res.data || {};
                    let successList = resData.list||[];
                    let errList = resData.err_list||[];

                    if(errList.length>0){

                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        let titleTxt = this.modalData.title;
                        htmlStr += '<p>The following '+titleTxt+' were not found，Please check if you need to cull these items ?</p>';
                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                        this.$confirm(htmlStr, 'Prompt', {
                            confirmButtonText: 'Exclude',
                            cancelButtonText: 'Close',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            customClass:'batch-err-tips-modal',
                            width:'500',
                        }).then(()=>{
                            this.batchCon = batchSearch.filter(item=>!errList.includes(item)).join('\n');
                            this.submitBatchModal();
                        });
                    }else{
                        console.log('successList',successList);

                        successList.forEach(item=>{
                            let resultItem = this.resultList.find(inner=>inner.id==item.id);
                            let dataItem = this.dataList.find(inner=>inner.id==item.id);
                            if(!resultItem){
                                this.resultList.push({
                                    checked:true,
                                    id:item.id,
                                    isHide:false,
                                    name:item.name,
                                });
                            }
                            if(dataItem){
                                dataItem.checked = true;
                            }

                        });
                        this.batchLoading = false;
                        this.batchVisible = false;
                        this.batchCon = '';
                    }

                    this.resetAllState();
                }, (err) => {
                    console.log('getConditions batch error', err);
                    this.batchLoading = false;
                    this.$message.error(err.info||'Request Error');
                });
            },
            changeIsExclude(command){
                this.formItem.isExclude = command==='exclude';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        /*width: 120px;*/
    }

    ::v-deep .el-dialog__body {
        padding: 20px;
    }

    .copy-btn-icon{
        position: absolute;
        display: inline-block;
        width: 20px;
        height: 20px;
        left: -30px;
        top: 8px;
        font-size: 20px;
        cursor: pointer;
        color: #409eff;
    }

    .result-wrap, .search-wrap {
        width: 50%;
        border: solid 1px #ccc;
        padding: 10px;
        height: 300px;
        overflow: hidden;
    }

    .result-wrap {
        position: relative;
        left: -1px;
    }

    .result-list {
        margin-top: 5px;
        height: 265px;
        overflow-y: auto;
        li{
            white-space: normal;
            line-height: 20px;
            padding: 0 20px 0 10px;
            &:hover{
                background-color: #f8f8f9;
            }
        }
        .clear-btn{
            padding: 0 8px;
            right: 0;
            top: 0;
        }
    }


    .search-list {
        width: 100%;
        min-height: 200px;
        max-height: 250px;
        overflow-y: auto;
        padding: 6px;
        ul{
            min-height: 100px;
        }
    }

    .hide-item{
        display: none;
    }

    .size18{
        font-size: 18px;
    }
    .active-icon{
        color: #409eff;
    }
    .ver-middle{
        vertical-align: middle;
    }
    .left30{
        left: -30px!important;
    }

    .exclude-drop{
        position: absolute;
        left: -60px;
        top: 8px;
        cursor: pointer;
    }



</style>
